import { DayTypeType } from '@shared';

export interface BookableEvent {
  apiId: number;
  slug: string;
}

export interface DayAvailability {
  date: Date;
  availableDaytypes: DayTypeType[];
}

export const bookableEvents: BookableEvent[] = [
  {
    apiId: 1,
    slug: "fruehlingsfest-2025"
  },
  {
    apiId: 2,
    slug: "volksfest-2025"
  }
];
